// extracted by css-extract-rspack-plugin
export default {"sentence":"NoticeModal__sentence--gX7gr"};